import {Dictionary} from "./utils";
export interface IWizard {
    questions:      IQuestion[]
    configurations: IConfiguration[]
    settings:       ISettings
}

export interface IQuestion {
    name: string
    title: string
    choices?: IFilterChoices
    isMultipleChoice?: boolean
    showContactForm?: boolean
    showQuote?: boolean
    showDetailsForm?: boolean
    showAddressForm?: boolean
    showSendEmailNote?: boolean
}

export interface IFilterChoices {
    [filter: string]: Array<IChoice|string>
}

export interface IChoice {
    name:         string
    altName?:     string
    image?:       string  // Relative path to the image
    imageOnly?:   boolean
    showTextbox?: boolean
}

export interface IReplacementPhoneData {
    device:   string
    model:    string
    capacity: string
    price:    string
}

export interface IConfigurationData {
    device:           string
    model:            string
    color:            string
    capacity:         string
    damage:           string
    price:            string
    replacementPrice: string
    markup:           string
}

export interface IConfiguration {
    configuration:     string[],
    price:             number,
    markup:            number,
    replacementPrice?: number,
}

export interface ISettings {
    vat: number     // A number 0..100 defining the VAT percentage
    labour: number  // Amount charged for labour
    courier: number // Amount that courier charges
}

export interface RowValidationError {
    row: number
    errors: string[]
}

export interface ContactFormData {
    name: string
    email: string
    subject: string
    message: string
}

export interface ContactFormRequest extends ContactFormData {
    hostname: string
}

export interface DetailsFormData {
    name: string
    surname: string
    email: string
    areaCode: string
    contactNumber: string
}

export interface AddressFormData {
    streetNumber: string
    streetName: string
    city: string
    country: string
    zipCode: string
}

export interface BasicRequestData {
    userChoices: string[],
    userChoicesDict: Dictionary<string>,
    contact: DetailsFormData,
    quote: number
    hostname: string
}

export interface EmailQuoteData extends BasicRequestData {
    key: string     // Array key of the email quote (currently not used - meant for linking back to the wizard)
    quoteNumber: string // The quote number that was generated by the server
    QUOTE_TYPES?:       any
    TRANSFER_DETAILS?:  any
    selectedQuoteType?: string
}

export interface StoreQuoteData extends BasicRequestData {
    feedUrl:            string
    QUOTE_TYPES?:       any
    TRANSFER_DETAILS?:  any
    selectedQuoteType?: string
}

export interface StoreWizardData extends StoreQuoteData {
    address: AddressFormData
}

export interface IReplacementPrice {
    capacity:         string
    replacementPrice: number
}

export const CAPACITY_INDEX = 3
export const ISSUES_INDEX = 4
export const DETAILS_INDEX = 5

export const QUOTE_STEP = 6
export const ADDRESS_FORM_STEP = 7
export const CONFIRMATION_STEP = 8

export enum EQuoteType {
    CollectAndRepair = 'Collect and Repair',
    InStoreRepair    = 'Repair in Store',
    Replacement      = 'Replacement'
}

export const TRANSFER_DETAILS = {
    BANK:           'FIRST NATIONAL BANK',
    ACCOUNT_NUMBER: '62772248607',
    COMPANY:        'PHONETRADR PTY LTD'
}
